import { useIntl } from 'react-intl';

import { ProductTileModel } from '@notino/react-styleguide';

import { messages } from '@containers/ProductDetailContainer/ProductDetail/ProductBaseInfo/VoucherDiscount/VoucherDiscountInfo/messages';
import { AttributeTypes } from '@containers/ProductListing/model';
import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

interface Attributes {
  VoucherDiscount?: {
    tags?: string[];
  };
  ConditionalVoucherDiscount?: {
    tags?: string[];
  };
  Dermo?: boolean;
  MarginUnderLimit?: boolean;
}

export function transformProductIcons(
  attributes: Attributes,
  formatMessage,
  isFranceShop?: boolean
): ProductTileModel.IProductIcon[] {
  return Object.keys(attributes)
    .map((key) => {
      if (
        key === AttributeTypes.VoucherDiscount ||
        key === AttributeTypes.ConditionalVoucherDiscount
      ) {
        const voucherDiscount =
          attributes.VoucherDiscount || attributes.ConditionalVoucherDiscount;

        if (!voucherDiscount) {
          return;
        }

        if (voucherDiscount.tags?.includes('summerblackfriday')) {
          return {
            icon: ProductTileModel.SpecialSales.summerBlackFriday,
            label: formatMessage(messages.sbfLabel),
            title: formatMessage(messages.sbfLabel),
            highlightedWordIndex: isFranceShop ? 2 : 0,
          };
        } else if (voucherDiscount.tags?.includes('blackfriday')) {
          return {
            icon: ProductTileModel.SpecialSales.blackFriday,
            label: formatMessage(messages.blackFridayLabel),
          };
        }
      } else if (key === 'Dermo') {
        return {
          icon: ProductTileModel.SpecialSales.recommendedByDermatologists,
        };
      } else if (key === 'MarginUnderLimit') {
        return {
          icon: ProductTileModel.SpecialSales.marginUnderLimit,
        };
      }
      return null;
    })
    .filter(Boolean) as ProductTileModel.IProductIcon[];
}

export const useGetProductIcons = () => {
  const { formatMessage } = useIntl();
  const isFranceShop = useApolloClientHeaders()?.shopId === 'notino.fr';

  return (
    attributes: Record<string, unknown>
  ): ProductTileModel.IProductIcon[] => {
    if (!attributes) return [];

    return transformProductIcons(attributes, formatMessage, isFranceShop);
  };
};
